import React, { useState } from "react";
import Navbar from "../Navbar";
import axios from "axios";
import SelectSearchInput from "../SelectSearch";
import Footer from "../Footer";

const CostCenter = () => {
  const Url = process.env.REACT_APP_BASE_URL;
  const today = new Date().toISOString().split("T")[0];
  const [databar, setDataBar] = useState([]);
  const [databartotal, setDataBarTotal] = useState([]);
  const [datakitchen, setDataKitchen] = useState([]);
  const [datakitchentotal, setDataKitchenTotal] = useState([]);
  // const [searchParams, setSearchParams] = useSearchParams();
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [token, setToken] = useState("");
  const [error, setError] = useState(null);
  const [selectedOutlet, setSelectedOutlet] = useState("");

  const handleCostCenter = async () => {
    // Clear previous data before fetching new data
    setDataBar([]);
    setDataBarTotal([]);
    setDataKitchen([]);
    setDataKitchenTotal([]);

    try {
      const response = await axios.post(
        `${Url}/costcenterwiseAllStockTransfers`,
        {
          outlet: selectedOutlet,
          startDate: startDate,
          endDate: endDate,
        }
      );

      // Check for the response data
      if (response && response.data) {
        const barData = response.data.find((item) => item.CostCenter === "Bar");
        const kitchenData = response.data.find(
          (item) => item.CostCenter === "Kitchen"
        );

        if (barData && barData.ItemDetailsList) {
          setDataBar(barData.ItemDetailsList);
          setDataBarTotal(barData.grand_total);
        } else {
          setDataBar([]);
        }

        if (kitchenData && kitchenData.ItemDetailsList) {
          setDataKitchen(kitchenData.ItemDetailsList);
          setDataKitchenTotal(kitchenData.grand_total);
        } else {
          setDataKitchen([]);
        }

        // Clear error if data is successfully fetched
        setError(null);
      } else {
        setDataBar([]);
        setDataKitchen([]);
        setError("No data found");
      }
    } catch (error) {
      // Handle API errors
      console.log("Error fetching data:", error);
      setError("Failed to fetch data. Please try again later.");
    }
  };

  return (
    <>
      <Navbar />

      <div className="my-4">
        <div className="flex justify-between items-center max-w-5xl mx-auto mt-3">
          <div className="flex items-center gap-2">
            <label className="font-base font-poppins md:text-base block">From:</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-28 md:w-36 text-xs md:text-base cursor-pointer border rounded px-1"
            />
          </div>

          <SelectSearchInput
            token={token}
            setToken={setToken}
            selectedOutlet={selectedOutlet}
            setSelectedOutlet={setSelectedOutlet}
          />

          <div className="flex items-center gap-2">
            <label className="font-base font-poppins md:text-base block">To:</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="w-28 md:w-36 text-xs md:text-base cursor-pointer border rounded px-1"
            />
          </div>
        </div>

        <div className="flex justify-center mt-3">
          <button
            className="px-4 py-2 text-xs border-2 border-slate-300 hover:bg-slate-100 bg-slate-700 text-zinc-100 hover:text-zinc-700 rounded-md"
            onClick={handleCostCenter}>
            Search
          </button>
        </div>

        {/* Display error message */}
        {error && (
          <div className="text-center text-red-500 mt-4">
            <strong>{error}</strong>
          </div>
        )}

        <div className="flex flex-col">
          {/* Kitchen Section */}
          <div className="flex flex-col">
            <div className="table-responsive-food">
              <div className="table-responsive-food-header">
                <div className="bg-heading-food">
                  <h4 className="food-heading">Kitchen</h4>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table-food">
                  <thead className="table-background">
                    <tr className="sticky-header bg-white">
                      <th>Group Name</th>
                      <th>Item Name</th>
                      <th>Brand Name</th>
                      <th>Amount</th>
                      <th>UOM</th>
                      <th>Rate</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {datakitchen.length > 0 ? (
                      datakitchen.map((item, index) => (
                        <tr key={index}>
                          <td>{item.GroupName}</td>
                          <td>{item.ItemName}</td>
                          <td>{item.BrandName || " "}</td>
                          <td>{item.Amount}</td>
                          <td>{item.UOM}</td>
                          <td>{item.Rate}</td>
                          <td>{item.Total}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot className="w-full mt-1 bg-white p-2 sticky bottom-0 -z-0">
                    <tr className="p-2 h-14 mb-0">
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th>
                        Total:{" "}
                        <span className="text-base">{datakitchentotal}</span>
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          {/* Bar Section */}
          <div className="flex flex-col">
            <div className="table-responsive-food">
              <div className="table-responsive-food-header">
                <div className="bg-heading-food">
                  <h4 className="food-heading">Bar</h4>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table-food">
                  <thead className="table-background">
                    <tr className="sticky-header bg-white">
                      <th>Group Name</th>
                      <th>Item Name</th>
                      <th>Brand Name</th>
                      <th>Amount</th>
                      <th>UOM</th>
                      <th>Rate</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {databar.length > 0 ? (
                      databar.map((item, index) => (
                        <tr key={index}>
                          <td>{item.GroupName}</td>
                          <td>{item.ItemName}</td>
                          <td>{item.BrandName || " "}</td>
                          <td>{item.Amount}</td>
                          <td>{item.UOM}</td>
                          <td>{item.Rate}</td>
                          <td>{item.Total}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot className="w-full mt-1 bg-white p-4 sticky bottom-0 -z-0">
                    <tr className="p-4 h-14">
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th>
                        Total: <span className="text-base">{databartotal}</span>
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CostCenter;
